goog.provide("shadow.js.shim.module$$hookform$devtools");
goog.provide("module$shadow_js_shim_module$$hookform$devtools");
shadow.js.shim.module$$hookform$devtools = shadow.js.nativeProvides["@hookform/devtools"] = shadow$bridge("@hookform/devtools");
module$shadow_js_shim_module$$hookform$devtools.default = shadow.js.shim.module$$hookform$devtools;
